const getCookie = (cookieName: string): string => {
  const prefix = `${cookieName}=`;
  const entries = document.cookie.split(';');

  for (const rawEntry of entries) {
    const entry = rawEntry.trim();
    if (entry.startsWith(prefix)) {
      return decodeURIComponent(entry.substring(prefix.length));
    }
  }

  return '';
};

const hasCategoryConsent = (cookieValue: string, requiredCategory: string): boolean => {
  const normalizedCategory = requiredCategory.replace(/^c/i, '');
  if (normalizedCategory === '') {
    return false;
  }

  let value = (cookieValue || '').toLowerCase();

  value = value.replace(/^setw?cm/, '').replace(/ts\d+.*$/, '');
  if (value === '' || value === 'min') {
    return false;
  }
  if (value === 'max') {
    return true;
  }

  const categoryRegex = /c(\d+)/g;
  let match: RegExpExecArray | null;

  while ((match = categoryRegex.exec(value)) !== null) {
    if (match[1] === normalizedCategory) {
      return true;
    }
  }

  return false;
};

const applyCookieConsentGates = (): void => {
  const wrappers = document.querySelectorAll<HTMLElement>('[data-cookie-state]');
  if (!wrappers.length) {
    return;
  }

  const cookieValue = getCookie('waconcookiemanagement');

  wrappers.forEach((wrapper) => {
    const requiredCategory = wrapper.dataset.requiredCategory ?? '';
    const content = wrapper.querySelector<HTMLElement>('[data-cookie-content]');
    const placeholder = wrapper.querySelector<HTMLElement>('[data-cookie-placeholder]');
    const allowed = hasCategoryConsent(cookieValue, requiredCategory);

    if (content) {
      content.hidden = !allowed;
    }
    if (placeholder) {
      placeholder.hidden = allowed;
    }
  });
};

applyCookieConsentGates();
